import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Loader from 'components/atoms/Spinner/Loader';
import { getParam } from 'controls/utils';
import { logout } from 'actions/auth';
import { Language } from 'language/Language';
import { googleAuth, facebookAuth } from './utils';

const OAuthPlugin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userInfo } = useSelector((state) => state);
  const language = Language();

  const hasLogged = getParam('hasLogged');
  const port = getParam('port');
  const provider = getParam('provider');

  const handleLogout = useCallback(async () => {
    await dispatch(logout(history, `${language === 'japan' ? '/jp' : ''}/auth?provider=${provider}${port ? `&port=${port}` : ''}`));
  }, [dispatch, history, language, port, provider]);
  useEffect(() => {
    const setHasLogged = () => {
      history.push(`?hasLogged=true${port ? `&port=${port}` : ''}`);
    };

    const providersFunctions = {
      google: googleAuth,
      facebook: facebookAuth,
    };

    const handleLogin = async () => {
      await providersFunctions[provider](dispatch);
      setHasLogged();
    };

    if (userInfo && provider) {
      handleLogout();
    } else if (provider && !hasLogged) {
      handleLogin();
    } else if (hasLogged === 'true') {
      /*
        the time out is necessary since the redirect to /auth/plugin must be done at the moment that hasLogged is true
        but this shows the form for an instant and the time out makes it impossible to see. And addition to making it possible
        for the user to change the login method since it redirects you to the form regardless of whether you are logged in or not,
        if you are logged in, you will login with the plugin and if the login fails with one provider the user decides whether to try again with another provider
      */
      setTimeout(() => {
        history.push(`${language === 'japan' ? '/jp' : ''}/auth/plugin${port ? `?port=${port}` : ''}`);
      }, 500);
    } else if (!provider) {
      handleLogout();
      history.push(`${language === 'japan' ? '/jp' : ''}/auth/plugin?redirected=true${port ? `&port=${port}` : ''}`);
    }
  }, [dispatch, handleLogout, hasLogged, history, language, provider, port, userInfo]);
  return (
    <Loader />
  );
};

export default OAuthPlugin;
